<template>
	<div id="Campaigns" class="flex-fill overflow-auto">
		<div v-if="showCampaignsLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<!-- Create Campaign Form -->
		<div class="rounded border bg-white m-3 text-center overflow-auto module1">
			<h5 class="border-bottom py-2 m-0">Create a Campaign</h5>
			<div class="overflow-auto">
				<!-- <b-form @submit.stop.prevent="createCampaign" class="p-3"> -->
				<div  class="p-3">
					<b-form-group label="Campaign Name: " class="text-left">
						<b-form-input
							v-model="form.name"
							required
						/>
					</b-form-group>
					<b-form-group label="Recipients: " class="text-left" style="margin-bottom: 0px;">
						<b-button-group class="w-100 campButtonGroup">
							<b-dropdown variant="outline" text="Prospects" class="border rounded-top-left flex-fill" no-caret no-flip>
								<b-dropdown-form class="position-relative">
									<b-form-input type="search" size="sm" v-model="prospSearch" />
								</b-dropdown-form>
								<b-dropdown-item-button @click="form.recipients.push(prosp)" :key="prosp.id" v-for="prosp in filteredProsps">
									{{$parseAlias(prosp)}}
								</b-dropdown-item-button>
							</b-dropdown>
							<b-dropdown variant="outline" text="Tags" class="border rounded-top-right flex-fill" no-caret>
								<template #default>
								<div style="max-height: 200px; overflow-y: auto;">
								<b-dropdown-item-button @click="addByTag(folder)" :key="folder" v-for="folder in user.Folders">
									{{folder}}
								</b-dropdown-item-button>
								</div>
								</template>
							</b-dropdown>
							<b-dropdown variant="outline" text="Stages" class="border rounded-top-right flex-fill" no-caret>
								<template #default>
								<div style="max-height: 200px; overflow-y: auto;">
								<b-dropdown-item-button @click="addByStage(stage)" :key="stage" v-for="stage in user.Stages">
									{{stage}}
								</b-dropdown-item-button>
								</div>
								</template>
							</b-dropdown>
						</b-button-group>
						
						<div v-if="this.form.recipients.length" class="spanLoopDataDiv">
							<div v-if="this.form.recipients.length">
								<span class="headi">Prospects :<span class="spaceAdd"></span></span> 
								<span>{{this.form.recipients.length}} </span>
							</div>
							<div v-if="tagArray.length" class="spanLoopData">
								<span class="headi">Tags :<span class="spaceAdd"></span></span>
								<span :key="item.id" v-for="item in tagArray">
									{{item.title}} ({{item.countNumber}}), 
								</span>
							</div>
							<div v-if="stageArray.length" class="spanLoopData">
								<span class="headi">Stages :<span class="spaceAdd"></span></span>
								<span :key="item.id" v-for="item in stageArray">
									{{item.title}} ({{item.countNumber}}), 
								</span>
							</div>
						</div>

						<b-list-group class="text-center" style="display:none;">
							<b-list-group-item
								button
								class="py-1"
								:key="prosp.id"
								@click="removeProsp(prosp)"
								v-for="prosp in form.recipients"
							>
								{{$parseAlias(prosp)}}
							</b-list-group-item>
						</b-list-group>
					</b-form-group>
					
					<b-form-group label="Message: " class="text-left schedule-textbox" style="position:relative;">
						<b-form-group class="dynamicformdiv">
							<b-form-select v-model="dynamicTags" @change="makeDynamicTags()">
								<b-form-select-option value="">Insert Variable</b-form-select-option>
								<option value="firstName">Prospect First Name</option>
								<option value="lastName">Prospect Last Name</option>
								<option value="email">Prospect Email</option>
								<option value="number">Prospect Number</option>
								<option value="OfficeName">Office Name</option>
								<option value="OfficeAddress">Office Address</option>
								<option value="ManagerFirstName">Manager First Name</option>
								<option value="ManagerLastName">Manager Last Name</option>
								<option value="ManagerEmail">Manager Email</option>
								<option value="ManagerNumber">Manager Number</option>
								<option value="InterviewDate">Interview Date</option>
								<option value="InterviewTime">Interview Time</option>
							</b-form-select>
						</b-form-group>
						<!--<b-button-group class="w-100">
							<b-button
								type="button"
								variant="outline"
								@click="insertTag('{{firstName}}')"
								class="border rounded-top-left flex-fill"
							>
								First
							</b-button>
							<b-button
								type="button"
								variant="outline"
								@click="insertTag('{{lastName}}')"
								class="border rounded-0 flex-fill"
							>
								Last
							</b-button>
							<b-button
								type="button"
								variant="outline"
								@click="insertTag('{{email}}')"
								class="border rounded-0 flex-fill"
							>
								Email
							</b-button>
							<b-button
								type="button"
								variant="outline"
								@click="insertTag('{{number}}')"
								class="border rounded-top-right flex-fill"
							>
								Number
							</b-button>
						</b-button-group>-->
						<input id="fileUpload" type="file" @change="changeFile($event)" hidden>
						<b-button  variant="outline" class="border" @click="chooseFiles" style="z-index: 9;position: absolute;left: 5px;top: 95px;width: 37px;height: 37px;padding: 0px;" >
							<v-icon name="upload" scale="1.5" class="text-blue" />
						</b-button>
						<b-button variant="outline" class="border schedule-upload schedule-upload1" @click="openTemplate" title="Templates">
						<v-icon name="file-alt" scale="1.5" class="m-2 text-blue" />
						</b-button>
						<twemoji-textarea 
							:emojiData="emojiDataAll" 
							:emojiGroups="emojiGroups" 
							:skinsSelection="false"
							:searchEmojisFeat="true"
							searchEmojiPlaceholder="Search here."
							searchEmojiNotFound="Emojis not found."
							ref="twemojiTextarea"
							placeholder="Type a message"
							v-model="form.body"
							class="twemojiTextarea flex-fill"
							@contentChanged="onContentChanged"			
							@keydown.enter.prevent
							spellcheck="true"
							v-focus
							style="min-height:115px">
						</twemoji-textarea>
						<div class="shiftenter">Press the (Shift + Enter) for new line</div>
						<!-- <b-form-textarea
							class="rounded-bottom border-top-0"
							v-model="form.body"
							ref="Message"
							no-resize
							required
							rows="4"
							spellcheck="true"
						/> -->
					</b-form-group>
					<div v-if="hideDiv" class="cam-view-layout">
						<span v-if="!uplodedFilePath">Loading...</span>
						<a class="cam-view-box" v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<img width="200" :src="uplodedFilePath"/>
						</a>
						<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="music" />
						</a>
						<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="video" />
						</a>
						<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="file" />
						</a>
						<b-button v-if="uplodedFilePath" variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
							<v-icon name="times"  scale="1.5" class=" m-2 text-blue" style="font-size: 1.5em;"/>
						</b-button>
					</div>
					<b-form-group label="Date/Time" class="text-left">
						<b-form-group>
							<b-form-datepicker
								:min="minDate"
								:max="maxDate"
								v-model="form.date"
								size="sm"
								required/>
						</b-form-group>
						<b-form-group>
							<b-form-timepicker
								v-model="form.time"
								size="sm"
								required/>
						</b-form-group>
					</b-form-group>
					<b-button-group class="w-100">
						<b-button variant="outline-primary" @click.stop.prevent="clearForm">Clear</b-button>
						<b-button type="submit" variant="outline-primary" @click="createCampaignTest">Save</b-button>
					</b-button-group>
				<!-- </b-form> -->
				</div>
			</div>
		</div>

		<!-- Manage Campaigns Table -->
		<div v-if="sortedCampaigns.length != 0" class="rounded border bg-white m-3 text-center overflow-auto module2">
			<h5 class="border-bottom py-2 mb-2">Manage Campaigns</h5>
			<b-table-simple bordered striped hover class="w-90 mx-auto text-left">
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Campaign Name</b-th>
						<b-th>Message</b-th>
						<b-th>Media</b-th>
					</b-tr>
				</b-thead>
				<b-tbody v-if="!showCampaignsLoader">
					<b-tr 
						:key="campaign.name"
						@click="editCampaign(campaign)"
						v-for="campaign in sortedCampaigns"
						class="text-left position-relative pointer"
						:class="{
							'table-danger': campaign.Status == 'error',
							'table-warning': campaign.Status == 'cancelled'
						}"
					>
						<b-td>{{campaign.Name}}</b-td>
						<b-td style="    display: flex;justify-content: space-between; align-items: center;" class="position-relative">
							<div class="mr-3" style="width: 85%">
								{{formatBody(campaign.Body)}}
							</div>
							<div
								style="top: 0; right: 0;width: 15%;"
								class="h-100"
							>
								<b-button 
									v-b-popover.hover.focus.html="popoverMethod(campaign)"
									class="no-glow"
									style="top: 0;padding: 0.375rem 0.2rem;"
									@click.stop.prevent
									variant="outline"
								>
									<v-icon class="text-blue" name="info" s />
								</b-button>
								<b-dropdown
									class="no-glow "
									style="bottom: 0"
									variant="outline"
									size="sm"
									no-caret
								>
									<template v-slot:button-content>
										<v-icon class="text-blue" name="times" />
									</template>
									<b-dropdown-item-button style="    padding: 0.375rem 0.2rem;" v-if="campaign.Status == 'scheduled'" @click.stop.prevent="clickcancelCampaign(campaign)">
										Cancel
									</b-dropdown-item-button>
									<b-dropdown-item-button style="    padding: 0.375rem 0.2rem;" @click.stop.prevent="deleteCampaign(campaign)">
										Delete
									</b-dropdown-item-button>
								</b-dropdown>
							</div>
						</b-td>
						<b-td >
							<a v-if="campaign.mediaUrl" style="display:block;text-decoration: none" target="blank"  :href="campaign.mediaUrl" >
								<v-icon scale="2.5" name="file" />
							</a>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
			<b-pagination
			v-model="currentPage"
			:total-rows="campaigns.length"
			:per-page="perPage"
			align="center"
			class="my-4"
			></b-pagination>
		</div>

		<b-modal id="TemplateModal" size="lg" hide-footer>
			<template v-slot:modal-title>
				Saved Templates
			</template>
			<b-table-simple bordered responsive striped hover sticky-header="28em" class="w-90 mx-auto text-left" >
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Template Name</b-th>
						<b-th>Message</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr
						class="text-left pointer"
						:key="i"
						v-for="(item,i) in user.Template"
						@click="fill(item)">
							<b-td>{{item.Name}}</b-td>
							<b-td>{{item.Message}}
								<!-- <a v-if="item.mediaUrl" class="p-0 mx-1 my-2 primary" style="display:block;text-decoration: none" target="blank"  :href="item.mediaUrl" >
									<v-icon scale="2.5" name="file" />
								</a> -->
								<a v-if="item.mediaUrl"  variant="outline" class="p-0 mx-1 my-2 primary">
									<v-icon scale="2.5" name="file" />
								</a>
							</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-modal>

	</div>
</template>

<script>
	import { db,fbstore, scheduleCampaign, scheduleCampaignTest, cancelCampaign } from 'src/db'
	import { mapState } from 'vuex'
	import { TwemojiTextarea } from '@kevinfaguiar/vue-twemoji-picker';
	import  EmojiAllData  from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json';
	import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
	import axios from "axios";

	export default {
		name: "Campaigns",
		components: {
			'twemoji-textarea': TwemojiTextarea
        },
		computed: {
			minDate() {
				return new Date();
			},
			maxDate() {
				let maxDate = new Date();
				maxDate.setDate(maxDate.getDate() + 365); // Add 365 days to the current date
				return maxDate;
			},
			sortedCampaigns() {
				return this.pagedItems.concat().sort((c1, c2) => c2.DateTime - c1.DateTime);
			},
			emojiDataAll() {
				return EmojiAllData;
			},
			emojiGroups() {
				return EmojiGroups;
			},
			filteredProsps() {
				if (this.prospects.length) {
					return this.prospects.filter(prosp => {
						return !this.form.recipients.includes(prosp) &&
							this.$parseAlias(prosp).toLowerCase().includes(this.prospSearch.toLowerCase());
					}).slice(0,5);
				}
				return [];
			},
			isImage() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.imageFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.audioFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.videoFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.documentFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			pagedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.campaigns.slice(start, end);
            },
			...mapState('firebase', ['user', 'prospects', 'campaigns'])
		},
		methods: {
			// MANAGE DYNAMIC TAGS
			makeDynamicTags() {
				if(this.dynamicTags) {
					this.insertTag(`{{${this.dynamicTags}}}`);
				}
			},
			popoverMethod(campaign) {
				return {
					html: true,
					title: () => {
						return '<b>Campaign Info</b>';
					},
					content: () => {
						return `
								<strong>Status: </strong>${campaign.Status}<br>
								<strong>Date: </strong>${this.$parseDate(campaign.DateTime)}<br>
								<strong>Recipients: </strong>${campaign.Recipients.length}<br>
							`
					}
				}
			},
			insertTag(text) {
				// eslint-disable-next-line
				// console.log(text)
				// let message = this.form.body;
				// let startPos = this.$refs.Message.selectionStart;
				// let endPos = this.$refs.Message.selectionEnd;
				// let startPos = this.$refs.twemojiTextarea.selectionStart;
				// let endPos = this.$refs.twemojiTextarea.selectionEnd;
				//eslint-disable-next-line
				// console.log(startPos,endPos)
				// this.form.body = message.slice(0, startPos);
				this.form.body = text;
				// this.form.body += message.slice(endPos);
				//eslint-disable-next-line
				// console.log(this.form.body)
				this.addText(this.form.body);
			},
			removeProsp(prosp) {
				let index = this.form.recipients.findIndex(recipient => recipient == prosp);
				this.form.recipients.splice(index, 1);
			},
			async createCampaign() {
				if (!this.form.date || !this.form.time) {
					alert("Sheduled Date/Time is reuired");
					return
				}
				let ms = new Date(`${this.form.date} ${this.form.time}`).valueOf();
				if (ms < this.minDate || ms > this.maxDate) {
					alert("Sheduled Date/Time is either in the past or further than 30 days in the future");
					return;
				}
				let noteMsg = "Prospect was added to the " + this.form.name + " campaign and is set to receive the campaign message on " + this.form.date +" "+ this.form.time;
				this.showCampaignsLoader = true;
				let allCampWithPhoneNo = [];
				this.form.recipients.forEach(element => {
					if (element.hasOwnProperty('Number') && element.Number) {
						allCampWithPhoneNo.push(element);
					}
				});
				let recSize = 50;
				if (allCampWithPhoneNo.length > recSize) {
					let tc = (allCampWithPhoneNo.length / recSize);
					tc = Math.ceil(tc);
					let mss = ms;
					for(let i = 1; i <= tc;) {
						let newArray = allCampWithPhoneNo.slice((i-1 )* recSize,(i * recSize));
						await this.executeSchedule(i,noteMsg,mss,newArray,tc);
						i++
						mss = mss + 1000;
						
					}
					
				}else {
					await this.executeSchedule(0,noteMsg,ms,allCampWithPhoneNo,1);
					// scheduleCampaign({
					// 	Name: this.form.name,
					// 	// Recipients: this.form.recipients.map(prosp => prosp.id),
					// 	Recipients: allCampWithPhoneNo.map(prosp => prosp.id),
					// 	Body: this.form.body,
					// 	DateTime: ms,
					// 	noteMsg:noteMsg,
					// 	mediaUrl:this.uplodedFilePath,
					// 	Uid:this.user.Uid,
					// 	id:this.user.id
					// })
					// .then(() => {
					// 	this.manageLoader(ms)
					// 	//eslint-disable-next-line
					// 	console.log(ms)
					// })
					// .catch(err => alert(`Failure scheduling message: ${err.response.data}`));
				}
				this.form = {
					name: '',
					body: '',
					date: '',
					time: '',
					recipients: []
				};
				this.uplodedFilePath = '';
				this.cleanText();
				this.hideDiv = false;
				this.showCampaignsLoader = false;
				this.$bvToast.toast('Campaign is being created! Please wait for a few seconds.', {
					title: `Campaign Info`,
					variant: 'info',
					solid: true,
					autoHideDelay: 3000,
				});
			},
			executeSchedule(i,noteMsg,mss,allCampWithPhoneNo,tc) {
				let campName = this.form.name;
				if (i) {
					campName = this.form.name+'_'+i;
				}
				scheduleCampaign({
						Name: campName,
						// Recipients: this.form.recipients.map(prosp => prosp.id),
						Recipients: allCampWithPhoneNo.map(prosp => prosp.id),
						Body: this.form.body,
						DateTime: mss,
						noteMsg:noteMsg,
						mediaUrl:this.uplodedFilePath,
						Uid:this.user.Uid,
						id:this.user.id
					})
					.then(() => {
						//eslint-disable-next-line
						console.log(tc)
						// if (i == 0) {
						// 	this.manageLoader(mss)
						// }else {
						// 	if ( i == tc){
						// 		this.showCampaignsLoader = false;
						// 		alert(`Message has been scheduled for ${this.$parseDate(mss)}`);
						// 	}
						// }
							
					})
					.catch(err => alert(`Failure scheduling message: ${err}`));
					
			},
			async createCampaignTest() {
				if (!this.form.date || !this.form.time) {
					alert("Sheduled Date/Time is reuired");
					return
				}
				let ms = new Date(`${this.form.date} ${this.form.time}`).valueOf();
				if (ms < this.minDate || ms > this.maxDate) {
					alert("Sheduled Date/Time is either in the past or further than 30 days in the future");
					return;
				}
				let noteMsg = "Prospect was added to the " + this.form.name + " campaign and is set to receive the campaign message on " + this.form.date +" "+ this.form.time;
				this.showCampaignsLoader = true;
				let allCampWithPhoneNo = [];
				this.form.recipients.forEach(element => {
					if (element.hasOwnProperty('Number') && element.Number) {
						allCampWithPhoneNo.push(element);
					}
				});
				let recSize = 50;
				if (allCampWithPhoneNo.length > recSize) {
					let tc = (allCampWithPhoneNo.length / recSize);
					tc = Math.ceil(tc);
					let mss = ms;
					for(let i = 1; i <= tc;) {
						let newArray = allCampWithPhoneNo.slice((i-1 )* recSize,(i * recSize));
						await this.executeScheduleTest(i,noteMsg,mss,newArray,tc);
						i++
						mss = mss + 1000;
						
					}
					
				}else {
					await this.executeScheduleTest(0,noteMsg,ms,allCampWithPhoneNo,1);
					// scheduleCampaign({
					// 	Name: this.form.name,
					// 	// Recipients: this.form.recipients.map(prosp => prosp.id),
					// 	Recipients: allCampWithPhoneNo.map(prosp => prosp.id),
					// 	Body: this.form.body,
					// 	DateTime: ms,
					// 	noteMsg:noteMsg,
					// 	mediaUrl:this.uplodedFilePath,
					// 	Uid:this.user.Uid,
					// 	id:this.user.id
					// })
					// .then(() => {
					// 	this.manageLoader(ms)
					// 	//eslint-disable-next-line
					// 	console.log(ms)
					// })
					// .catch(err => alert(`Failure scheduling message: ${err.response.data}`));
				}
				this.form = {
					name: '',
					body: '',
					date: '',
					time: '',
					recipients: []
				};
				this.uplodedFilePath = '';
				this.cleanText();
				this.hideDiv = false;
				this.showCampaignsLoader = false;
				this.$bvToast.toast('Campaign is being created! Please wait for a few seconds.', {
					title: `Campaign Info`,
					variant: 'info',
					solid: true,
					autoHideDelay: 3000,
				});
			},
			executeScheduleTest(i,noteMsg,mss,allCampWithPhoneNo,tc) {
				let campName = this.form.name;
				if (i) {
					campName = this.form.name+'_'+i;
				}
				scheduleCampaignTest({
						Name: campName,
						// Recipients: this.form.recipients.map(prosp => prosp.id),
						Recipients: allCampWithPhoneNo.map(prosp => prosp.id),
						Body: this.form.body,
						DateTime: mss,
						noteMsg:noteMsg,
						mediaUrl:this.uplodedFilePath,
						Uid:this.user.Uid,
						id:this.user.id
					})
					.then((resp) => {
						//eslint-disable-next-line
						console.log('tc', tc)
						//eslint-disable-next-line
						console.log('resp', resp);
						const campaigns = resp.data.data;

						// Loop through each campaign and send the API request
						campaigns.forEach(async(campaign) => {
						const smsData = {
							pid: campaign.pid,
							cid: campaign.cid,
							body: campaign.body,
							SendOn: campaign.SendOn,
							campaigndocId:campaign.campaigndocId,
							mediaUrl: campaign.mediaUrl,
						};

						// Make the API call
						await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/automatedSms",smsData)
						.then((response) => {
							//eslint-disable-next-line
							console.log("SMS Sent Successfully:", response.data);
						})
						.catch((error) => {
							//eslint-disable-next-line
							console.error("Error Sending SMS:", error.message);
						});
						});

						// if (i == 0) {
						// 	this.manageLoader(mss)
						// }else {
						// 	if ( i == tc){
						// 		this.showCampaignsLoader = false;
						// 		alert(`Message has been scheduled for ${this.$parseDate(mss)}`);
						// 	}
						// }
							
					})
					.catch(err => alert(`Failure scheduling message: ${err}`));
					
			},
			manageLoader(ms) {
				this.showCampaignsLoader = false;
				alert(`Message has been scheduled for ${this.$parseDate(ms)}`);
				// this.sortedCampaigns();
			},
			clickcancelCampaign(campaign) {
				if (confirm("Campaign "+ campaign.Name  +" is being cancelled. Campaign status will be updated in a moment.")) {
					let i = this.campaigns.indexOf(campaign);
					let cid = this.campaigns[i].id;
					// db.doc(`Users/${this.user.id}/Campaigns/${this.campaigns[i].id}`).update({ Status: 'cancelled' });
					cancelCampaign({
						userId:this.user.id,
						cid: cid,
					})
					.then((res) => {
						this.returnedCam(res);
					})
					.catch(err => alert(`Failure in cancel campaign: ${err}`));
				}
			},
			returnedCam(res) {
				// eslint-disable-next-line
				console.log(res)
			},
			deleteCampaign(campaign) {
				if (confirm("Campaign "+ campaign.Name  +" is being deleted. Campaign status will be removed in a moment.")) {
					let i = this.campaigns.indexOf(campaign);
					if (this.campaigns[i].Status == "scheduled") {
						let cid = this.campaigns[i].id;
						cancelCampaign({
							userId:this.user.id,
							cid: cid,
						})
						.then((res) => {
							this.returnedCam(res);
							db.doc(`Users/${this.user.id}/Campaigns/${this.campaigns[i].id}`).delete();
						})
						.catch(err => alert(`Failure in cancel campaign: ${err}`));
					}else {
						db.doc(`Users/${this.user.id}/Campaigns/${this.campaigns[i].id}`).delete();
					}
				}
				// db.doc(`Users/${this.user.id}/Campaigns/${this.campaigns[i].id}`).delete();
			},
			editCampaign(campaign) {
				let recipients = this.prospects.filter(prospect => campaign.Recipients.includes(prospect.id));
				let date = new Date(campaign.DateTime);
				this.form.name = campaign.Name;
				this.form.body = campaign.Body;
				this.uplodedFilePath = campaign.mediaUrl;
				if (this.uplodedFilePath) {
					this.hideDiv = true
				}else {
					this.hideDiv = false
				}
				
				this.form.date = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
				this.form.time = `${date.getHours()}:${date.getMinutes()}:00`;
				this.form.recipients = recipients;
				this.cleanText();
				this.addText(this.form.body);
			},
			addByStage(stage) {
				this.form.recipients.push(...this.prospects.filter(prosp => prosp.Status &&
					prosp.Status == stage && !this.form.recipients.includes(prosp)));
				
				let stageArray1 = this.stageArray; 
				var check = stageArray1.includes(stage);
				if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false)
					let getPros = this.prospects.filter(pr => pr.Status && pr.Status == stage);
					var exists = stageArray1.some(function(field) {
						return field.title === stage
					});
					if (!exists) {
						stageArray1.push({title:stage, countNumber: getPros.length});
					}
				}
				//eslint-disable-next-line
				// console.log('this.stageArray', stageArray1);
			},
			addByTag(tag) {
				this.form.recipients.push(...this.prospects.filter(prosp => prosp.Tags &&
					prosp.Tags.includes(tag) && !this.form.recipients.includes(prosp)));

				let tagArray1 = this.tagArray; 
				var check = tagArray1.includes(tag);
				if(!check) {
					let getTags = this.prospects.filter(prosp => prosp.Tags &&
					prosp.Tags.includes(tag));
					var exists = tagArray1.some(function(field) {
						return field.title === tag
					});
					if (!exists) {
						tagArray1.push({title:tag, countNumber: getTags.length});
					}
				}
				//eslint-disable-next-line
				// console.log('this.tagArray', tagArray1);
			},
			formatBody(str) {
				return str.length > 200 ? str.substring(0, 200) + "..." : str;
			},
			clearForm() {
				this.cleanText();
				this.form = {
					name: '',
					body: '',
					date: '',
					time: '',
					recipients: []
				};
				this.tagArray = [];
				this.stageArray = [];
				this.removeFile();
			},
			onContentChanged(c) {
				this.form.body = c;
			},
			cleanText() {
				this.$refs.twemojiTextarea.cleanText();
			},
			addText(text) {
				this.$refs.twemojiTextarea.addText(text);
			},
			changeFile(event) {
				this.uploadValue = 0;
				this.uplodedFilePath = '';
				this.fileData = event.target.files[0];
				if (this.supportedType.includes(this.fileData.type)) {
					if (this.fileData.size < 5242880) {
						this.hideDiv = true;
						this.onUpload();
					}else {
						alert('File size must be less than 5MB');
					}
				}else {
					alert('This format is not allowed');
				}
				
			},
			onUpload(){
				this.uplodedFilePath = '';
				const storageRef = fbstore.ref(`${this.fileData.name}`).put(this.fileData);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{
						this.uplodedFilePath = url;
						// this.send({});
					});
				});
			},
			chooseFiles() {
				document.getElementById("fileUpload").click()
			},
			removeFile() {
				this.uplodedFilePath = '';
				this.hideDiv = false;
			},
			openTemplate() {
				this.$bvModal.show('TemplateModal')
			},
			fill(item) {
				let message = item.Message
				if (item && item.hasOwnProperty('mediaUrl') && item.mediaUrl) {
					this.uplodedFilePath = item.mediaUrl;
					this.hideDiv = true;
				}
				this.form.body = message;
				// if (this.prospect) {
				// 	let edited = message.replace(/{{firstName}}/g, this.prospect.First ? this.prospect.First : '');
				// 	edited = edited.replace(/{{lastName}}/g, this.prospect.Last ? this.prospect.Last : '');
				// 	edited = edited.replace(/{{email}}/g, this.prospect.Email ? this.prospect.Email : '');
				// 	edited = edited.replace(/{{number}}/g, this.$parseNumber(this.prospect.Number));
				// 	this.form.body = edited;
				// 	this.$bvModal.hide('TemplateModal');
				// }
				// else {
				// 	this.form.body = message;
				// 	this.$bvModal.hide('TemplateModal');
				// }
				this.$bvModal.hide('TemplateModal');
				this.addText(this.form.body);
			},
		},
		data() {
			return {
				dynamicTags: '',
				tagArray: [],
				stageArray: [],
				form: {
					name: '',
					body: '',
					date: '',
					time: '',
					recipients: []
				},
				prospSearch: '',
				showCampaignsLoader:false,
				uploadValue: 0,
				uplodedFilePath: '',
				fileData: null,
				hideDiv:false,
				supportedType: ['audio/basic','audio/L24','audio/mp4','audio/mpeg','audio/ogg','audio/vorbis','audio/vnd.rn-realaudio',
					'audio/vnd.wave','audio/3gpp','audio/3gpp2','audio/ac3','audio/vnd.wave','audio/webm','audio/amr-nb','audio/amr',
					'video/mpeg','video/mp4','video/quicktime','video/webm','video/3gpp','video/3gpp2','video/3gpp-tt','video/H261',
					'video/H263','video/H263-1998','video/H263-2000','video/H264','image/jpeg','image/gif','image/png','image/bmp',
					'text/vcard','text/csv','text/rtf','text/richtext','text/calendar','text/directory','application/pdf'
					],
					imageFormatArray:['jpg','jpeg','png','gif','bmp'],
				audioFormatArray:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArray:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264',],
				documentFormatArray:['pdf','vcard','csv','rtf','richtext','calendar','directory'],
				currentPage: 1,
                perPage: 10,
			}
		}
	}
</script>

<style scoped>
.loader1 {
position: fixed;
z-index: 1010;
top: 50%;
margin: auto;
left: 50%;
z-index: 1111;
}

.loader1:before {
content: "";
display: block;
position: fixed;
top: 0;
left: 0;
width: 100%;
min-height: 100%;
background-color: rgba(0, 0, 0, 0.3);
z-index: 1111;
}

.lds-ripple {
display: inline-block;
top: 50%;
position: relative;
width: 64px;
height: 64px;
}

.lds-ripple div {
position: absolute;
top: 50%;
border: 4px solid #000000;
opacity: 1;
border-radius: 50%;
animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
animation-delay: -0.5s;
}

@keyframes lds-ripple {
0% {
top: 28px;
left: 28px;
width: 0;
height: 0;
opacity: 1;
}
100% {
top: -1px;
left: -1px;
width: 58px;
height: 58px;
opacity: 0;
}
}
	th,
	td {
		border-color: lightgray !important;
	}
	.submit {
		background-image: radial-gradient(powderblue, skyblue);
		box-shadow: 2px 2px 5px gray;
		color: black;
	}
	.submit:disabled {
		background-image: none;
		background-color: pink;
		color: red;
	}
	.b-row {
		font-size: 1.2em;
	}
	.rounded-top-left {
		border-radius: 5px 0 0 0;
	}
	.rounded-top-right {
		border-radius: 0 5px 0 0;
	}
	.rounded-bottom {
		border-radius: 0 0 5px 5px;
	}
	.no-glow:focus {
		border-color: transparent;
		box-shadow: 0px 1px 1px rgba(0, 0, 0, 0) inset, 0px 0px 0px rgba(255, 100, 255, 0);
	}

	.cam-view-box img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border: 4px solid #042b79;
}

.cam-view-box {
    position: relative;
}
.cam-view-layout .btn-outline {
    position: absolute;
    top: -27px;
    right: -15px;
    background: white;
    border-radius: 100%;
}
.cam-view-layout {
    position: relative;
}
.schedule-textbox .schedule-upload {
    /* bottom: 0 !important; */
    left: 5px !important;
    /* top: 50px !important; */
    position: absolute !important;
    z-index: 9;
    /* top: 0; */
    padding: 5px 7px !important;
    margin-bottom: 10px !important;
}
.schedule-textbox .schedule-textbox .twemoji-textarea-outer {
    max-height: 140px;
    min-height: 150px !important;
}
.schedule-textbox div#twemoji-textarea {
    min-height: 140px;
}
.schedule-textbox div#twemoji-textarea{
	margin-left: 0 !important;
}

</style>
<style>
.campButtonGroup .dropdown-toggle{
	font-size: 14px;
}
.spanLoopDataDiv{
	padding: 10px 0px;
}
.spanLoopData .headi{
	float:left;
}
.spaceAdd{
	padding: 0px 2px;
}
</style>